module.exports = __webpack_public_path__ + "img/plexus-2.8023734a.png";